import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { jsx } from 'react/jsx-runtime';
import { InputText } from '@dls/web';
import styled from 'styled-components';
import img from '../../assets/svgs/search-secondary.svg.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const SearchInput = props => {
  const _a = props,
    {
      width = "100%",
      alt = "Search",
      className,
      bgColor = "haze",
      label = "Search"
    } = _a,
    otherProps = __objRest(_a, ["width", "alt", "className", "bgColor", "label"]);
  return /* @__PURE__ */jsx(SearchContainer, {
    $width: width,
    className,
    children: /* @__PURE__ */jsx(InputText, __spreadValues({
      icon: {
        src: img,
        alt
      },
      label,
      bgColor
    }, otherProps))
  });
};
const SearchContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  img {\n    width: 24px !important;\n  }\n"])), props => typeof props.$width === "string" ? props.$width : props.$width + "px");
export { SearchInput as default };